import type { SelectOption } from '@shinetools/lumen-react'

import type { TaxRate } from '@modules-deprecated/app/taxrates/types'

export const getPurchaseTaxRateOptions = (taxRates: TaxRate[]): SelectOption[] =>
  taxRates
    .filter((taxRate) => taxRate.appliesToPurchases)
    .map((taxRate) => ({
      label: taxRate.name,
      value: taxRate.id,
    }))
